import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Home";
import PrivacyPolicy from "./PrivacyPolicy";
import Terms from "./Terms";
import Contact from "./Contact";
import RemoveAccount from "./RemoveAccount";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" >
          <Route index element={<Home />} />
          <Route path="privacypolicy" element={<PrivacyPolicy />} />
          <Route path="terms" element={<Terms />} />
          <Route path="contact" element={<Contact />} />
          <Route path="removeaccount" element={<RemoveAccount />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;